"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/** @jsx jsx */
var react_1 = require("@emotion/react");
var react_2 = __importStar(require("react"));
var icons_1 = require("../../../icons");
var style_1 = require("../../../style");
var input_1 = require("../../input");
var layout_1 = require("../../layout");
var Tooltip_1 = __importDefault(require("../../Tooltip"));
var EmptyState_1 = __importDefault(require("../EmptyState"));
var Cell_1 = __importDefault(require("./Cell"));
var styles_1 = __importDefault(require("./styles"));
function Table(_a) {
    var children = _a.children, className = _a.className, data = _a.data, _b = _a.emptyDescription, emptyDescription = _b === void 0 ? '' : _b, _c = _a.emptyIllustration, emptyIllustration = _c === void 0 ? 'NoData' : _c, _d = _a.emptyTitle, emptyTitle = _d === void 0 ? '' : _d, onSelect = _a.onSelect, rowKey = _a.rowKey, selected = _a.selected, size = _a.size, totalDatasetSize = _a.totalDatasetSize;
    var isSelectMode = Boolean(selected);
    var _e = react_2.useState(undefined), sortField = _e[0], setSortField = _e[1];
    var _f = react_2.useState('asc'), sortOrder = _f[0], setSortOrder = _f[1];
    var sortedTable = react_2.useMemo(function () {
        var sorted = data;
        if (sortField) {
            sorted = __spreadArrays(data).sort(function (a, b) {
                var _a;
                return ((_a = JSON.stringify(a[sortField])) === null || _a === void 0 ? void 0 : _a.localeCompare(JSON.stringify(b[sortField]), 'en', {
                    numeric: true,
                })) * (sortOrder === 'asc' ? 1 : -1);
            });
        }
        return sorted;
    }, [sortField, sortOrder, data]);
    var handleSortingChange = function (accessor) {
        var newSortOrder = accessor === sortField && sortOrder === 'asc' ? 'desc' : 'asc';
        setSortField(accessor);
        setSortOrder(newSortOrder);
    };
    var handleSortingFunction = function (accessor, sortOptions) {
        var newSortOrder = sortOptions.sortOrder === 'asc' ? 'desc' : 'asc';
        sortOptions.sortFunc(accessor, newSortOrder);
    };
    var getSortDirection = function (sortOptions) {
        if (sortOptions && sortOptions.sortOrder) {
            return sortOptions.sortOrder;
        }
        else {
            return sortOrder;
        }
    };
    var renderOptions = function (props) {
        var sortOptions = props.sortOptions, sortKey = props.sortKey, help = props.help, filter = props.filter, _a = props.onFilterClick, onFilterClick = _a === void 0 ? function () { return ({}); } : _a;
        var sortDirection = getSortDirection(sortOptions);
        var isASC = sortDirection === 'asc' &&
            (sortField === sortKey || (sortOptions && sortOptions.sortField === sortKey));
        var isDESC = sortDirection === 'desc' &&
            (sortField === sortKey || (sortOptions && sortOptions.sortField === sortKey));
        return (react_1.jsx(layout_1.Flex, null,
            help && (react_1.jsx(Tooltip_1.default, { overlay: help, css: styles_1.default.help },
                react_1.jsx(icons_1.HelpCircle, { size: 16, color: style_1.DesignSystemColor.Gray.LIGHT_1 }))),
            sortKey && (react_1.jsx("span", { onClick: sortOptions
                    ? function () { return handleSortingFunction(sortKey, sortOptions); }
                    : function () { return handleSortingChange(sortKey); }, css: styles_1.default.sortContainer },
                react_1.jsx(icons_1.ArrowNarrowUp, { css: styles_1.default.icon(Boolean(isASC)) }),
                react_1.jsx(icons_1.ArrowNarrowDown, { css: [styles_1.default.icon(Boolean(isDESC)), styles_1.default.iconDown] }))),
            filter !== undefined && (react_1.jsx(icons_1.FilterFunnel, { css: styles_1.default.filter, color: filter ? style_1.DesignSystemColor.Blue.DEFAULT : style_1.DesignSystemColor.Gray.LIGHT_1, onClick: onFilterClick }))));
    };
    var handleOnSelect = function (id) {
        if (!selected) {
            return;
        }
        var nextSelected = new Set(selected);
        if (nextSelected.has(id)) {
            nextSelected.delete(id);
            onSelect(nextSelected, false);
        }
        else {
            nextSelected.add(id);
            onSelect(nextSelected, false);
        }
    };
    var handleOnSelectAll = function (checked) {
        if (checked) {
            onSelect(new Set(data.map(rowKey)), true);
        }
        else {
            onSelect(new Set(), true);
        }
    };
    var renderCheckbox = function (rowData) {
        var id = rowKey === null || rowKey === void 0 ? void 0 : rowKey(rowData);
        return (react_1.jsx(layout_1.Flex, { alignItems: "center", justifyContent: "center" },
            react_1.jsx(input_1.Checkbox, { label: "", checked: Boolean(selected === null || selected === void 0 ? void 0 : selected.has(id)), onChange: function () { return handleOnSelect(id); }, indeterminate: false })));
    };
    var renderEmpty = function () {
        return !rows.length && (react_1.jsx("tr", null,
            react_1.jsx("td", { colSpan: headerColumns.length + (selected ? 1 : 0), align: "center", css: styles_1.default.emptyTd },
                react_1.jsx(EmptyState_1.default, { level: { illustration: emptyIllustration, position: 'center' }, title: emptyTitle, description: emptyDescription }))));
    };
    var headerColumns = children.map(function (_a) {
        var props = _a.props;
        var header = props.header;
        return (react_1.jsx("th", { key: header === null || header === void 0 ? void 0 : header.toString(), css: [styles_1.default.header] },
            react_1.jsx("div", { css: styles_1.default.headerContainer },
                react_1.jsx("span", null, header),
                renderOptions(props))));
    });
    var rows = sortedTable.map(function (dataElem) { return (react_1.jsx("tr", { css: styles_1.default.row(selected === null || selected === void 0 ? void 0 : selected.has(rowKey(dataElem))), key: rowKey(dataElem) },
        isSelectMode && (react_1.jsx(Cell_1.default, { cellSize: size, css: styles_1.default.checkboxCell }, renderCheckbox(dataElem))),
        children.map(function (_a) {
            var _b;
            var props = _a.props;
            return 'dataKey' in props ? (react_1.jsx(Cell_1.default, { cellSize: size, key: props.header ? props.header.toString() : undefined }, dataElem[props.dataKey])) : (react_1.jsx(react_2.default.Fragment, { key: (_b = props.header) === null || _b === void 0 ? void 0 : _b.toString() }, props.children({ size: size, data: dataElem })));
        }))); });
    return (react_1.jsx("table", { css: [styles_1.default.table], className: className },
        react_1.jsx("thead", null,
            react_1.jsx("tr", null,
                isSelectMode && (react_1.jsx("th", { css: [styles_1.default.header, styles_1.default.checkboxCell] },
                    react_1.jsx(layout_1.Flex, { alignItems: "center", justifyContent: "center" },
                        react_1.jsx(input_1.Checkbox, { label: "", checked: Boolean(data.length
                                && (selected === null || selected === void 0 ? void 0 : selected.size) === (totalDatasetSize || data.length)), onChange: handleOnSelectAll, indeterminate: Boolean(selected === null || selected === void 0 ? void 0 : selected.size) })))),
                headerColumns)),
        react_1.jsx("tbody", null,
            rows,
            renderEmpty())));
}
function Column(props) {
    return props ? null : null; // fix no-unused-vars
}
exports.default = Object.assign(Table, { Column: Column, Cell: Cell_1.default });
